import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ProductDetailModal = ({ product, onClose }) => {
  if (!product) return null;

  const DetailSection = ({ title, content, iconName }) => (
    <div>
      <h4 className="flex items-center font-heading font-heading-medium text-sm text-card-foreground mb-2">
        <Icon name={iconName} size={14} className="mr-2 text-accent" />
        {title}
      </h4>
      <p className="font-body font-body-normal text-sm text-muted-foreground leading-relaxed">
        {content || 'Details not available.'}
      </p>
    </div>
  );

  return (
    <div 
      className="fixed inset-0 z-modal bg-background/80 backdrop-blur-sm"
      onClick={onClose}
    >
      <div className="flex items-center justify-center min-h-screen p-4">
        <div 
          className="bg-card border border-border rounded-clinical shadow-clinical-lg max-w-2xl w-full max-h-[90vh] overflow-hidden flex flex-col"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <div className="flex items-center justify-between p-5 border-b border-border">
            <div className="flex flex-col">
                <span className="font-caption font-caption-normal text-xs text-muted-foreground uppercase tracking-wide">{product.category}</span>
                <h2 className="font-heading font-heading-semibold text-lg text-card-foreground -mt-0.5">
                {product.name}
                </h2>
            </div>
            <Button
              variant="ghost"
              size="icon"
              onClick={onClose}
              iconName="X"
              iconSize={20}
            >
              <span className="sr-only">Close</span>
            </Button>
          </div>

          <div className="flex-1 overflow-y-auto">
            <div className="grid grid-cols-1 md:grid-cols-2">
                {/* Product Image */}
                <div className="p-6 md:border-r md:border-border">
                    <div className="aspect-square overflow-hidden rounded-clinical bg-muted">
                        <Image
                            src={product.image || 'https://placehold.co/400x400/f1f5f9/334155?text=Product'}
                            alt={product.name}
                            className="w-full h-full object-cover"
                        />
                    </div>
                </div>

                {/* Product Info */}
                <div className="p-6 space-y-6">
                    <DetailSection title="Description" content={product.description} iconName="FileText" />
                    <DetailSection title="Usage" content={product.usage} iconName="Clock" />
                    <DetailSection title="Application" content={product.application} iconName="Droplet" />
                    <DetailSection title="Tips" content={product.tips} iconName="Sparkles" />
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailModal;
